






























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from "@/definitions";

import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import { TextInfo } from '@/utilityModels/textInfo';
import { MathHelper } from '@/helper/mathHelper';
import { FontManager } from '@/model/fontManager/fontManager';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    DropdownList,
    FontSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})

// テキスト編集中かつ文字列選択中
// このとき、設定は選択文字列のみに反映する。
export default class PlainTextStyleSelected extends Vue
{
    @Prop() private layer!: PlainTextLayer;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    // フォントザイズが自動かどうか
    private get autoSize() { return this.layer.autoSize; }

    // startPosition -> endPositionのtextInfoの配列
    private get currentTextInfoArray()
    {
        var array = new Array();
        var start = Math.min(this.layer.startPosition, this.layer.endPosition);
        var end = Math.max(this.layer.startPosition, this.layer.endPosition);
        var indexArray = this.layer.getLineAndCharacterIndexArrayFromPositionRange(start, end);
        for(var indexPair of indexArray)
        {
            var info = this.layer.getCharacterInfo(indexPair.lineIndex, indexPair.characterIndex);
            var textInfo = info != null ? info.textInfo : this.layer.baseTextInfo;
            array.push(textInfo);
        }

        return array;
    }

    private getCurrentValueInfo(propertyName)
    {
        // デフォルト値
        var defaultValue = this.layer.baseTextInfo[propertyName];
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = defaultValue;

        for(var i = 0; i < this.currentTextInfoArray.length; ++i)
        {
            var textInfo = this.currentTextInfoArray[i];
            var newValue = textInfo[propertyName];
            if(i > 0 && !MathHelper.equals(newValue, value))
            {
                isSameAll = false;
                value = defaultValue;
                break;
            }
            value = newValue;
        }

        return { value : value, isBlank : !isSameAll };
    }

    private getCurrentColorInfo(propertyName)
    {
        // デフォルト値
        var defaultValue = this.layer.baseTextInfo[propertyName];
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = defaultValue;

        for(var i = 0; i < this.currentTextInfoArray.length; ++i)
        {
            var textInfo = this.currentTextInfoArray[i];
            var newValue = textInfo[propertyName];
            if(i > 0 && !newValue.equals(value))
            {
                isSameAll = false;
                value = defaultValue;
                break;
            }
            value = newValue;
        }

        return { value : value, isBlank : !isSameAll };
    }

    private getPropertyValue(propertyName) { return this.getCurrentValueInfo(propertyName).value; }
    private getPropertyBlank(propertyName) { return this.getCurrentValueInfo(propertyName).isBlank; }

    isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private getFontManager() : FontManager
    {
        return this.$store.getters.fontManager;
    }
    private get selectedFontId() { return this.getCurrentFontId(); }
    private getCurrentFontId()
    {
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = "";
        for(var i = 0; i < this.currentTextInfoArray.length; ++i)
        {
            var textInfo = this.currentTextInfoArray[i];
            var newValue = textInfo.fontId;
            if(i > 0 && value != newValue)
            {
                isSameAll = false;
                break;
            }
            value = newValue;
        }
        return isSameAll ? value : "";
    }
    private onSelectFont(fontId : string)
    {
        this.changeTextInfo(fontId, "fontId", true, true);
    }

    private get textColor() { return this.getCurrentColorInfo("textColor").value; }
    private get textColorStyle()
    {
        var colorInfo = this.getCurrentColorInfo("textColor");
        return colorInfo.isBlank ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : colorInfo.value.hex };
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    textTransformContentsOpenAnimate = false;
    textTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.textTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.textTransformContentsCloseAnimate = false;
            this.textTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.textTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.textTransformContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓チェックボックスのアニメーション↓↓↓↓↓
    private get bold()
    {
        // すべてbold : true
        // それ以外 : false
        var bold = true;
        for(var textInfo of this.currentTextInfoArray)
        {
            if(!textInfo.bold)
            {
                bold = false;
                break;
            }
        }

        return bold;
    }

    private boldChange()
    {
        this.changeTextInfo(!this.bold, "bold", true);
    }

    private get italic()
    {
        // すべてitalic : true
        // それ以外 : false
        var italic = true;
        for(var textInfo of this.currentTextInfoArray)
        {
            if(!textInfo.italic)
            {
                italic = false;
                break;
            }
        }

        return italic;
    }

    private italicChange()
    {
        this.changeTextInfo(!this.italic, "italic", true);
    }

    private get underline()
    {
        // すべてunderline : true
        // それ以外 : false
        var underline = true;
        for(var textInfo of this.currentTextInfoArray)
        {
            if(!textInfo.underline)
            {
                underline = false;
                break;
            }
        }

        return underline;
    }

    private underlineChange()
    {
        this.changeTextInfo(!this.underline, "underline", true);
    }

    private get isEmQuad()
    {
        // すべてisEmQuad : true
        // それ以外 : false
        var isEmQuad = true;
        for(var textInfo of this.currentTextInfoArray)
        {
            if(!textInfo.isEmQuad)
            {
                isEmQuad = false;
                break;
            }
        }

        return isEmQuad;
    }

    private isEmQuadChange()
    {
        this.changeTextInfo(!this.isEmQuad, "isEmQuad", true);
    }

    private get isHorizontalInVertical()
    {
        // すべてisHorizontalInVertical : true
        // それ以外 : false
        var isHorizontalInVertical = true;
        for(var textInfo of this.currentTextInfoArray)
        {
            if(!textInfo.isHorizontalInVertical)
            {
                isHorizontalInVertical = false;
                break;
            }
        }

        return isHorizontalInVertical;
    }

    private isHorizontalInVerticalChange()
    {
        this.changeTextInfo(!this.isHorizontalInVertical, "isHorizontalInVertical", true);
    }
    //↑↑↑↑↑チェックボックスのアニメーション↑↑↑↑↑

    //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
    //こいつはpropsでいらない
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }
    //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

    // 色変更中
    private onChangingColor(color)
    {
        this.changeTextInfo(color, "textColor", false);
    }

    // 色変更完了
    private onChangedColor(color)
    {
        this.changeTextInfo(color, "textColor", true);
    }

    get opacity() {
        return this.layer.opacity;
    }

    set opacity(opacity) {
        if (this.getDecimalPointsLength(opacity) <= 1)
        {
            //小数点17個とかできちゃう

            opacity *= 100;

            if (this.layer.opacity != opacity)
            {
                this.changeLayerProperty(opacity, "opacity");
            }
        }
    }

    //小数点以下の数を数える
    getDecimalPointsLength(number)
    {
        var numbers = String(number).split("."),
        result = 0;

        if (numbers[1])
        {
            result = numbers[1].length;
        }

        return result;
    }

    private onChangingValue(value : number, tag : string)
    {
        this.changeTextInfo(value, tag, false);
    }

    private onChangedValue(value : number, tag : string)
    {
        this.changeTextInfo(value, tag, true);
    }

    private changeTextInfo(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        var textInfoArray = new Array();
        for(var textInfo of this.currentTextInfoArray)
        {
            // 文法の一部書き換え
            var newTextInfo = textInfo.clone();
            newTextInfo[propertyName] = value;
            textInfoArray.push(newTextInfo);
        }

        this.$emit("doCommand", "changePlainTextLayerRangeTextInfo", {
            layer : this.layer,
            textInfoArray : textInfoArray,
            startPosition : Math.min(this.layer.startPosition, this.layer.endPosition),
            endPosition : Math.max(this.layer.startPosition, this.layer.endPosition),
            isFinish : isFinish,
            isOnce : isOnce
        });
    }


    private changeLayerProperty(value: any, propertyName: string) {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    private get fontStyle()
    {
        var fontId = this.getCurrentFontId();
        return {
            'font-family' : this.getFontFamily(fontId),
            'font-weight' : this.getFontWeight(fontId)
        };
    }

    private getFontFamily(fontId : string)
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(fontId);
    }

    private getFontWeight(fontId : string) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);
        if(font.weight == null) { return "normal"; }
        return font.weight.toString();
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
